import { render, staticRenderFns } from "./dal-comp-talk.vue?vue&type=template&id=10813220"
import script from "./dal-comp-talk.vue?vue&type=script&lang=js"
export * from "./dal-comp-talk.vue?vue&type=script&lang=js"
import style0 from "./dal-comp-talk.vue?vue&type=style&index=0&id=10813220&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports